var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "navbar" }, [
    _c(
      "div",
      { staticClass: "flex-container" },
      [
        _c(
          "adam-header-bar",
          {
            attrs: { notifications: "[]" },
            domProps: {
              userName: _vm.user.name,
              emailAddress: _vm.user.email,
              showNotifications: false,
            },
            on: { "apps-click": _vm.clickDrawer },
          },
          [
            _c(
              "div",
              { attrs: { slot: "headerContent" }, slot: "headerContent" },
              [
                _c(
                  "div",
                  { staticClass: "flex-col nav-links top-row-content" },
                  [
                    _c(
                      "router-link",
                      { staticClass: "title pr-1", attrs: { to: "/report" } },
                      [
                        _c("img", {
                          staticClass: "logo",
                          attrs: {
                            src: require("@/assets/uniper-visual-coode-WHITE_green-orange-blue_RGB.svg"),
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "separator" }),
                _c(
                  "div",
                  { staticClass: "flex-col nav-links top-row-content" },
                  [_vm._v(" " + _vm._s(_vm.$t("easTitle")) + " ")]
                ),
              ]
            ),
            _c(
              "div",
              { attrs: { slot: "profileDetails" }, slot: "profileDetails" },
              [
                _c("div", { staticClass: "flex-col profile-container" }, [
                  _c("div", { staticClass: "profile-details" }, [
                    _c("div", { staticClass: "pb-1" }, [
                      _c(
                        "button",
                        {
                          staticClass: "copy-token-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.copyToken()
                            },
                          },
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.$t("copyToken")) + " "),
                          _c("font-awesome-icon", { attrs: { icon: "copy" } }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "pb-1" }, [
                      _c(
                        "a",
                        {
                          staticClass: "swagger-link",
                          attrs: { href: _vm.swaggerURL, target: "_blank" },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("openSwagger")) + " ")]
                      ),
                    ]),
                    _c("div", { staticClass: "flex-col flex-3 pb-1" }, [
                      _c("div", { staticClass: "version" }, [
                        _vm._v(
                          _vm._s(_vm.$t("version")) + " " + _vm._s(_vm.version)
                        ),
                      ]),
                      _c("div", { staticClass: "version" }, [
                        _vm._v(_vm._s(_vm.$t("apiUrl")) + "  "),
                        _c(
                          "a",
                          {
                            staticClass: "swagger-link",
                            attrs: { href: _vm.apiUrl },
                          },
                          [_vm._v(" " + _vm._s(_vm.apiUrl) + " ")]
                        ),
                      ]),
                    ]),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "contact-ai-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.openQueryHub()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "profile-action-icon" }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("profile.contactAI")) + " "
                          ),
                        ]
                      ),
                    ]),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "send-feedback-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.goToSendFeedback()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("sendFeedback")) + " ")]
                      ),
                    ]),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "report-incident-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.goToReportIncident()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("reportIncident")) + " ")]
                      ),
                    ]),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "logout-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.logOut()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("signOut")) + " ")]
                      ),
                    ]),
                  ]),
                  _c("input", {
                    staticClass: "copy-text",
                    attrs: { type: "text", id: "copyText" },
                  }),
                ]),
              ]
            ),
          ]
        ),
        _c(
          "app-drawer",
          {
            ref: "appDrawer",
            domProps: {
              data: _vm.applications,
              labels: _vm.getAppDrawerLabels,
              onClick: _vm.handleAppClick,
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "app-logo",
                attrs: { slot: "appLogo" },
                slot: "appLogo",
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/uniper-visual-coode-BLUE_green-orange-blue_RGB.svg"),
                  },
                }),
                _c("img", {
                  attrs: {
                    src: require("adam.ui-core/assets/brand/logo-enerlytics-rgb.svg"),
                  },
                }),
              ]
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }